<div class="d-flex justify-content-center">
    <div class="d-flex flex-column page-container">
        <div class="page-content-container">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
